import _classCallCheck from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/codebuild/output/src3305341033/src/hvorigins/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Layout } from '@solana/buffer-layout';
import { publicKey } from '@solana/buffer-layout-utils';
export var COptionPublicKeyLayout = /*#__PURE__*/function (_Layout) {
  _inherits(COptionPublicKeyLayout, _Layout);

  var _super = _createSuper(COptionPublicKeyLayout);

  function COptionPublicKeyLayout(property) {
    var _this;

    _classCallCheck(this, COptionPublicKeyLayout);

    _this = _super.call(this, -1, property);
    _this.publicKeyLayout = publicKey();
    return _this;
  }

  _createClass(COptionPublicKeyLayout, [{
    key: "decode",
    value: function decode(buffer) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var option = buffer[offset];

      if (option === 0) {
        return null;
      }

      return this.publicKeyLayout.decode(buffer, offset + 1);
    }
  }, {
    key: "encode",
    value: function encode(src, buffer) {
      var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      if (src === null) {
        buffer[offset] = 0;
        return 1;
      } else {
        buffer[offset] = 1;
        this.publicKeyLayout.encode(src, buffer, offset + 1);
        return 33;
      }
    }
  }, {
    key: "getSpan",
    value: function getSpan(buffer) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (buffer) {
        var option = buffer[offset];
        return option === 0 ? 1 : 1 + this.publicKeyLayout.span;
      }

      return 1 + this.publicKeyLayout.span;
    }
  }]);

  return COptionPublicKeyLayout;
}(Layout);